const BannerHyfye = () => {
    return (
  <section id="home_section" className="section_banner bg_black_dark wp_pattern d-flex align-items-center overflow_hide">
    <canvas id="banner_canvas" className="transparent_effect"></canvas>
    <div className="container">
      <div className="row align-items-center">
  
        {/* Left Side Content */}
        <div className="col-lg-6 col-md-12 col-sm-12 order-lg-first">
          <div className="banner_text text_md_center">
            
            <h1 className="animation text-white" data-animation="fadeInUp" data-animation-delay="1.1s">
              Welcome to Hyfye — The Universal Tip Coin
            </h1>
  
            <p className="animation text-white" data-animation="fadeInUp" data-animation-delay="1.3s">
              Phase 1: Launching Hyfye Coin (HYE) — the first global digital currency to reward every meaningful action across the world, online and offline.
            </p>
  
            <p className="animation text-white" data-animation="fadeInUp" data-animation-delay="1.4s">
              Phase 2: Building a full decentralized platform where users can tip, earn, buy, sell, and participate in the new global creator economy.
            </p>
  
            <div className="btn_group animation" data-animation="fadeInUp" data-animation-delay="1.5s">
              <a href="/assets/document/hyfye-official.pdf" className="btn btn-default nav-link content-popup" download>
                <i className="fa fa-file-word-o"></i>Whitepaper
              </a>
              <a href="https://www.pinksale.finance/launchpad/bsc/0x837f3E47CF89E716D22DbB9Bb38cedAb46248A1B" className="btn btn-border-white" target="_blank">
                <i className="fa fa-ge"></i>Buy Token
              </a>
            </div>
  
            {/* Hidden Whitepaper Popup */}
            <div id="whitepaper" className="team_pop mfp-hide">
              <div className="row m-0">
                <div className="col-md-7">
                  <div className="pt-3 pb-3">
                    <div className="title_dark title_border">
                      <h4>Download Whitepaper</h4>
                      <p>
                        Understand Hyfye's mission, tokenomics, future roadmap, and how we are building the next decentralized global economy of gratitude.
                      </p>
                      <a href="/assets/document/hyfye-official.pdf" className="btn btn-default" download>
                        Download Now <i className="ion-ios-arrow-thin-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-5">
                  <img className="pt-3 pb-3" src="assets/images/whitepaper.png" alt="whitepaper" />
                </div>
              </div>
            </div>
  
          </div>
        </div>
  
        {/* Right Side Token Progress */}
        <div className="col-lg-5 offset-lg-1 col-md-8 offset-md-2 col-sm-12 order-first">
          <div className="banner_inner res_md_mb_50 res_xs_mb_30">
            <div className="tk_countdown transparent_bg tk_border_white rounded-0 text-center animation" data-animation="fadeIn" data-animation-delay="1.1s">
              <div className="banner_text tk_counter_inner">
                <div className="tk_countdown_time p-0 transparent_bg box_shadow_none animation" data-animation="fadeInUp" data-animation-delay="1.2s"></div>
                <div className="progress animation" data-animation="fadeInUp" data-animation-delay="1.3s">
                  <div className="progress-bar progress-bar-striped gradient" role="progressbar" aria-valuenow="0.01" aria-valuemin="0" aria-valuemax="100" style={{ width: "7%" }}>
                    0%
                  </div>
                  <span className="progress_label bg-white" style={{ left: "7%" }}><strong>0% Raised</strong></span>
                  <span className="progress_label bg-white" style={{ left: "98%" }}><strong>Soft Cap Target</strong></span>
                  <span className="progress_min_val">Sale Raised</span>
                  <span className="progress_max_val">Soft Cap</span>
                </div>
              </div>
            </div>
          </div>
        </div>
  
      </div>
  
      {/* Divider */}
      <div className="row">
        <div className="col-12">
          <div className="divider small_divider"></div>
        </div>
      </div>
  
      {/* Accepted Crypto Section */}
      <div className="row">
        <div className="col-md-7 text_sm_center">
          <span className="text-white icon_title animation" data-animation="fadeInUp" data-animation-delay="1.4s">
            Currently Accepting:
          </span>
          <ul className="list_none currency_icon">
            <li className="animation" data-animation="fadeInUp" data-animation-delay="1.5s">
              <i className="cc BC"></i><span>BNB (Binance Smart Chain - BEP-20)</span>
            </li>
            <li className="animation" data-animation="fadeInUp" data-animation-delay="1.6s">
              <i className="cc USDT"></i><span>USDT (BEP-20)</span>
            </li>
          </ul>
        </div>
      </div>
  
      {/* Divider */}
      <div className="row">
        <div className="col-12">
          <div className="divider small_divider"></div>
        </div>
      </div>
  
    </div>
  </section>
  )};
  
  export default BannerHyfye;
  